import { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

interface IInfoV2Props extends ComponentPropsWithoutRef<"div"> {
  required?: boolean;
}

export const InfoV2 = ({
  className,
  children,
  required,
  ...rest
}: IInfoV2Props) => {
  return (
    <div
      className={twMerge(
        "rounded-[10px] bg-[#e8e8e8] px-5 py-3 text-start md:text-center text-base text-[#20332f] w-full max-w-7xl mx-auto",
        className,
      )}
      {...rest}
    >
      {required && <span className="text-red-600">* </span>}
      {children}
    </div>
  );
};
